import { Modal, Result, Button } from 'antd';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { statusTokens, primaryShades } from '../../../theme/theme';

// Colori dal tema
const WARNING_COLOR = statusTokens.warning;
const PRIMARY_COLOR = primaryShades.primary300;

/**
 * Confirmation modal for closing the bulk add modal
 * 
 * @param {Object} props - Component properties
 * @param {boolean} props.visible - Whether the modal is visible
 * @param {Function} props.onCancel - Function to call when canceling the close
 * @param {Function} props.onConfirm - Function to call when confirming the close
 */
const ConfirmCloseModal = ({ visible, onCancel, onConfirm }) => {
    return (
        <Modal
            open={visible}
            onCancel={onCancel}
            centered
            footer={null}
        >
            <Result
                icon={<WarningAmberIcon style={{ color: WARNING_COLOR, fontSize: 64 }} />}
                title="Are you sure you want to close this process?"
                subTitle="All uploaded data and progress will be permanently deleted. You will need to restart the entire bulk upload process from the beginning if you wish to continue later."
                extra={[
                    <Button
                        key="discard"
                        type="primary"
                        danger
                        onClick={onConfirm}
                        style={{ backgroundColor: PRIMARY_COLOR, borderColor: PRIMARY_COLOR }}
                    >
                        Close
                    </Button>,
                    <Button
                        key="cancel"
                        onClick={onCancel}
                        style={{ borderColor: PRIMARY_COLOR, color: PRIMARY_COLOR }}
                    >
                        Continue
                    </Button>
                ]}
            />
        </Modal>
    );
};

export default ConfirmCloseModal;
